import { useAuth } from '@drycut/auth';
import { Queues } from '@drycut/stylist-components';
import { useNavigate } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

export function Queue(): React.ReactNode {
  useDocumentTitle('DRYCUT - Queue');

  const navigate = useNavigate();
  const { currentSlug } = useAuth();

  if (!currentSlug) {
    navigate('/not-found');
    return null;
  }

  return <Queues slug={currentSlug} />;
}
